import { render, staticRenderFns } from "./RoutingForm.vue?vue&type=template&id=4fabef4a&"
import script from "./RoutingForm.vue?vue&type=script&lang=js&"
export * from "./RoutingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports